import colors from 'constants/colors'

export const accent = colors.black
